import { useIntercomLauncher } from '@/components/app/intercom/useIntercomLauncher'

export function useIntercom() {
    const { show } = useIntercomLauncher()

    return { show }
}
